// tslint:disable:component-selector

import { AfterViewInit, Component, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { RtiMessageBusService } from '../../../service/common/rti-MessageBusService';
import { Base } from '../../../../core/common/base';
import { Action } from '../../../../core/common/action';

@Component({
  selector: 'rti-modal-dialog',
  templateUrl: './rti-modal-dialog.html',
  styleUrls: ['./rti-modal-dialog.scss'],
})
export class RtiModalDialog extends Base {
  // tslint:disable-next-line
  @Input('template') body: TemplateRef<any>;
  @Input() actions: Action[];

  /**
   * Ioen()
   */
  public Open() {
    this.messageService.dispatch({
      event: 'open'
    });
  }

  /**
   * Close()
   */
  public Close() {
    this.messageService.dispatch({
      event: 'close'
    });
  }

  /**
   * OnCancel()
   */
  public OnCancel($event: KeyboardEvent) {
    $event.preventDefault();
    $event.stopPropagation();
  }

  /**
   * OnAction()
   */
  public OnAction(item: Action) {
    item.onClick();
    setTimeout(() => {
      this.Close();
    }, 10);
  }

  /**
   * constructor()
   */
  constructor(private messageService: RtiMessageBusService) {
    super();
    this.actions = [];
  }
}
